import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import LayoutOne from "../layouts";
import Breadcrumb from "../components/UI/breadcrumb";

const About = () => {
    return (
        <Fragment>
            <MetaTags>
                <title>Adaptive Systems LLC | Privacy Policy</title>
                <meta
                    name="description"
                    content=""
                />
            </MetaTags>
            <LayoutOne>
                <Breadcrumb title="Privacy Policy" />
                <div className="container pt--60 pb--60">
                    <h4>Effective Date: 07 july 2025 </h4>

                    <p>At Adaptive Systems LLC, we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and share data when you use our website.</p>

                    <h4>Information We Collect</h4>

                    <ul>
                        <li>Information you provide: name, email, phone number, ZIP code, and other details submitted through our forms.</li>
                        <li>Automatic information: IP address, browser type, device information, and website usage data.</li>
                        <li>Cookies and tracking: We use cookies, analytics tools, and Microsoft UET tags to measure performance.</li>
                    </ul>

                    <h4>How We Use Your Information</h4>
                    <ul>
                        <li>To provide you with internet and TV plan options.</li>
                        <li>To contact you by phone, email, or SMS with information you requested.</li>
                        <li>To improve website functionality and marketing performance.</li>
                    </ul>

                    <h4>Sharing of Information</h4>
                    <ul>
                        <li>We may share your information with trusted service providers, internet/TV retailers, or affiliates to help match you with plan options.</li>
                        <li>We do not sell personal information to third parties.</li>
                    </ul>

                    <h4>Data Retention</h4>
                    <p>We retain your information only as long as necessary to provide services, comply with legal obligations, and resolve disputes.</p>



                    <h4>Your Rights</h4>
                    <ul>
                        <li>You may opt out of marketing communications at any time.</li>
                        <li>You may request access, correction, or deletion of your personal information.</li>
                    </ul>


                    <h4>Security</h4>
                    <p>We use SSL encryption, secure hosting, and industry-standard safeguards to protect your data.</p>

                    <h4>Contact Us</h4>
                    <p>If you have questions, email us at info@adaptivesystems-llc.com</p>
                </div>
            </LayoutOne>
        </Fragment>
    );
};

export default About;
